<template>
    <div>
        <div class="form-feed">
            <div class="gcmcn-form-title">Add Programmation</div>
            <div class="gcmcn-card form-feed">
                <el-form :model="form" :rules="rules" ref="form">
                    <div class="flex-basis-6">
                        <el-form-item class="gcmcn-form-input" prop="display_name">
                            <div class="gcmcn-form-label">Name</div>
                            <el-input
                                size="mini"
                                v-model="form.display_name"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div class="text-right">
                        <el-button
                            type="text"
                            @click="leave"
                        >
                            Cancel
                        </el-button>
                        <el-button
                            type="primary"
                            class="gcmcn-primary-btn small"
                            @click="validateForm"
                        >
                            Save
                        </el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'programming-form',

    data () {
        return {
            form: {},
        };
    },
    computed:{
        rules (){
            let rules = {
                display_name: [{ required: true, validator: this.authorizedCharacters }],
            };
            return rules;
        },
    },
    methods: {
        leave (){
            this.$emit('leave-form-view');
        },
        validateForm(){
            console.log('Validate programming form');
        }
    }
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/Channels/programming-form.vue